import Headline from '@/components/basic/Headline/Headline';

interface InfoHeaderProps {
  text: string;
}

const InfoHeader = ({ text }: InfoHeaderProps) => {
  return (
    <header>
      <div className="tc-hero">
        <div className="tc-container">
          <Headline text={text} noBottomMargin />
        </div>
      </div>
    </header>
  );
};

export default InfoHeader;
